import { render, staticRenderFns } from "./FishUnlockModal.vue?vue&type=template&id=12e01254&"
import script from "./FishUnlockModal.vue?vue&type=script&lang=ts&"
export * from "./FishUnlockModal.vue?vue&type=script&lang=ts&"
import style0 from "./FishUnlockModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports